module.exports = __webpack_public_path__ + "static/media/wood-bg.2729e38b.png";